// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/common/css/global.css';
import './assets/common/moviicon/iconfont.css';
import http from '../http'
import '../node_modules/swiper/swiper-bundle.css';   //swiper6.0样式路径
import Swiper, { Navigation, Autoplay, Thumbs } from 'swiper'; //相关组件
import api from "./service/api.js";
import store from './store/index';
import Meta from "vue-meta";
import FUnitls from './utils/public.js'
import VueSession from 'vue-session'
import VueCookies from 'vue-cookies'
import VueLazyload from "vue-lazyload";
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import $ from 'jquery'


window.jQuery = $
window.$ = $
Vue.use(VueCookies)
Vue.use(VueSession)
Vue.use(VueLazyload)
Vue.use(VueVideoPlayer)

//将封装的接口挂载到vue原型上
Vue.prototype.$api = api;
Swiper.use([Navigation, Autoplay, Thumbs]);
Vue.prototype.$http = http
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Meta)
Vue.prototype.$FUnitls = FUnitls;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
router.beforeEach((to, from, next) => {
  // if(to.name=='brandinfo'&&to.params.id==1){
  //   next({name:'brand',params:to.params})
  // }else if(to.name=='brand'&&to.params.id!=1){
  //   next({name:'brandinfo',params:to.params})
  // }


  if (to.name == 'userindex' && localStorage.getItem("currentUser_token") == "") {
    next({ name: 'login' })
  }

  if (to.name == 'useractivate' && localStorage.getItem("currentUser_token") != "") {
    next({ name: 'index' })
  }
  if (to.name == 'resetpassword' && !(localStorage.getItem("currentUser_token") == "" || localStorage.getItem("currentUser_token") == null)) {
    next({ name: 'index' })
  }
  if (to.name == 'findpassword' && !(localStorage.getItem("currentUser_token") == "" || localStorage.getItem("currentUser_token") == null)) {
    next({ name: 'index' })
  }
  //console.log(localStorage.getItem("currentUser_token"));
  if (to.name == 'register' && !(localStorage.getItem("currentUser_token") == "" || localStorage.getItem("currentUser_token") == null)) {
    next({ name: 'index' })
  }

  if (to.name == 'brandinfo' && (to.params.id > 5&&to.params.id<9) || to.name == 'brand' && (to.params.id > 5&&to.params.id<9)) {
    // var options={
    //   message:"即将上新，敬请期待",
    // }
    // ElementUI.Message.warning(options)  
    FUnitls.showInfo('即将上新，敬请期待', 'info');
  } else {
    next()
  }



})



// WEBPACK FOOTER //
// ./src/main.js